import { DataExport } from 'model/dataExports';
import { Action } from 'redux';

export const DATA_EXPORTS_ERROR = 'dataExports/error';
interface DataExportsErrorAction extends Action<typeof DATA_EXPORTS_ERROR> {
    payload: {
        error: string;
    };
}

export const DATA_EXPORTS_RESET = 'dataExports/reset';
type DataExportsResetAction = Action<typeof DATA_EXPORTS_RESET>;

export const DATA_EXPORTS_FETCH_START = 'dataExports/fetch_start';
type DataExportsFetchStartAction = Action<typeof DATA_EXPORTS_FETCH_START>;

export const DATA_EXPORTS_FETCH_SUCCESS = 'dataExports/fetch_success';
interface DataExportsFetchSuccessAction extends Action<typeof DATA_EXPORTS_FETCH_SUCCESS> {
    payload: {
        dataExports: Array<DataExport>;
    };
}

export const DATA_EXPORTS_CREATE_START = 'dataExports/create_start';
type DataExportsCreateStartAction = Action<typeof DATA_EXPORTS_CREATE_START>;

export const DATA_EXPORTS_CREATE_SUCCESS = 'dataExports/create_success';
interface DataExportsCreateSuccessAction extends Action<typeof DATA_EXPORTS_CREATE_SUCCESS> {
    payload: {
        dataExport: DataExport;
    };
}

export type DataExportsAction =
    | DataExportsErrorAction
    | DataExportsResetAction
    | DataExportsFetchStartAction
    | DataExportsFetchSuccessAction
    | DataExportsCreateStartAction
    | DataExportsCreateSuccessAction;
